// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU9_thecomp__i2bBI"};